import { render, staticRenderFns } from "./page-view-map.vue?vue&type=template&id=0c4235d3&"
import script from "./page-view-map.vue?vue&type=script&lang=js&"
export * from "./page-view-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports